module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header navbar navbar-default navbar-fixed-top",
    attrs: {
      "id": "header"
    }
  }, [_c('div', {
    staticClass: "container-fluid"
  }, [(_vm.th === 'old') ? _c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "src": _vm.logo
    }
  }), _vm._v(" " + _vm._s(_vm.title))]), _vm._v(" "), _vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.th === 'new') ? _c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "javascript:;"
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100px"
    },
    attrs: {
      "src": 'https://www.nfjuara.id/wp-content/uploads/2021/08/logo-nf.png'
    }
  }), _vm._v("  Admin")]), _vm._v(" "), _vm._m(1)]) : _vm._e(), _vm._v(" "), _c('ul', {
    staticClass: "nav navbar-nav navbar-right"
  }, [_c('li', {
    staticClass: "dropdown navbar-user"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    attrs: {
      "src": this.picture,
      "alt": "avatar"
    },
    on: {
      "error": function($event) {
        this.src = '~@/assets/img/avatar-default.svg'
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.username))]), _vm._v(" "), _c('b', {
    staticClass: "caret"
  })]), _vm._v(" "), _c('ul', {
    staticClass: "dropdown-menu animated fadeInLeft"
  }, [_c('li', {
    staticClass: "arrow"
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.changeTheme
    }
  }, [_vm._v("Change Theme")])]), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.handleLogout
    }
  }, [_vm._v("Log Out")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-click": "sidebar-toggled"
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "navbar-toggle",
    attrs: {
      "type": "button",
      "data-click": "sidebar-toggled"
    }
  }, [_c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  }), _vm._v(" "), _c('span', {
    staticClass: "icon-bar"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7e504c2b","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/layout/Header.vue
// module id = 1374
// module chunks = 0